import { render, staticRenderFns } from "./WorkOtherPersonsPanel.vue?vue&type=template&id=c2842588"
import script from "./WorkOtherPersonsPanel.vue?vue&type=script&lang=js"
export * from "./WorkOtherPersonsPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkOtherPersonsPanel.vue?vue&type=style&index=0&id=c2842588&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports